import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartBar, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const PendingBillingBarChart = ({ data, isLoading }) => {
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [{
      label: '',
      data: [],
      backgroundColor: [],
    }]
  });

  useEffect(() => {
    if (!isLoading && data && data.length > 0) {
      const processData = () => {
        const clienteCounts = {};
        const facturistaTotals = {};

        data.forEach(item => {
          const names = item.FacturistaNombre.split(' ');
          const facturista = `${names[0]} ${names[names.length - 1]}`;
          clienteCounts[facturista] = (clienteCounts[facturista] || 0) + 1;
          facturistaTotals[facturista] = (facturistaTotals[facturista] || 0) + 1;
        });

        // Create an array of { facturista, total } objects, sort it, and then map to labels and totals
        const sortedFacturistas = Object.entries(facturistaTotals)
          .map(([facturista, total]) => ({ facturista, total }))
          .sort((a, b) => b.total - a.total);

        const labels = sortedFacturistas.map(entry => entry.facturista);
        const totals = sortedFacturistas.map(entry => entry.total);

        setChartData({
          labels,
          datasets: [{
            label: 'Total per Facturista',
            data: totals,
            backgroundColor: 'rgba(54, 162, 235, 0.6)',
          }],
        });
      };

      processData();
    }
  }, [data, isLoading]);

  const options = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        anchor: 'end',
        align: 'top',
        backgroundColor: 'rgba(173, 216, 230, 0.85)',
        borderRadius: 4,
        color: '#000',
        font: {
          weight: 'bold',
        },
        formatter: (value) => value > 0 ? value : '',
      },
    },
    maintainAspectRatio: false,
  };

  return (
    <div className="bg-white shadow rounded-lg p-4 w-full max-w-lg h-custom-card-big flex flex-col justify-between">
      <div className="mb-4">
        <h2 className="text-lg font-bold text-gray-800 flex items-center">
          <FontAwesomeIcon icon={faChartBar} className="text-blue-600 mr-2" />
          Traffic Productivity Chart
        </h2>
      </div>
      <div className="flex-grow relative">
        {isLoading ? (
          <div className="flex justify-center items-center h-full">
            <FontAwesomeIcon icon={faSpinner} className="animate-spin text-xl" />
            <span className="ml-2 text-lg">Loading...</span>
          </div>
        ) : (
          <Bar data={chartData} options={options} />
        )}
      </div>
    </div>
  );
};

export default PendingBillingBarChart;
